// extracted by mini-css-extract-plugin
export default {"btnn":"styles_btnn__Bx8Y4","btnnNo":"styles_btnnNo__u63Zn","btnnYes":"styles_btnnYes__z-6CI","label":"styles_label__gX1JS","input":"styles_input__64lkN"};